import { images } from "../assets/img";

export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/zPJQ5snKDSkkmuBh7",
  address: "107 Trafalgar road SE10 9TS",
  ggMapIframeUrl:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3587.751027395423!2d0.0015448!3d51.4843283!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d8a9ba569dd613%3A0x71dd2ad5a514b7a8!2sFriendly%20nail%20and%20beauty!5e1!3m2!1sen!2s!4v1764239858916!5m2!1sen!2s",
  email: "leenguyen0573@gmail.com",
  tel: "+447455483018",
  phone: "+44 745 548 3018",
  facebookId:"61584134760175",
  instagramName: "friendly.nail.and.beauty.x",
  // tiktok: "https://tiktok.com/@blue.pearl.nails",
  name: "Friendly Nail & Beauty",
  bookingUrl: "",
  openingTime:{
    openTime:{weekdays: "MONDAY - SATURDAY", time:"10:00 - 19:00"},
    closeTime:{weekdays: "SUNDAY", time:"10:00 - 17:00"}
  }
};

NAIL_SHOP_INFO.instagram = `https://www.instagram.com/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.instagramChatUrl = `https://ig.me/m/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.facebook = `https://www.facebook.com/profile.php?id=${NAIL_SHOP_INFO.facebookId}`
NAIL_SHOP_INFO.facebookMessengerUrl = `http://m.me/${NAIL_SHOP_INFO.facebookId}`

export const SOLCO_INFO = {
  facebook: "https://www.facebook.com/solcoagency.marketing",
  website: "https://huacatluong.com",
};

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};

export const CUSTOMER_FEEDBACK = [
  {
    name: "Chloe Anderson",
    feedback:
      "“The calm atmosphere here is amazing. From the moment I walked in, I felt completely at ease. My nails look perfect every single time, and the team always goes the extra mile to make sure I’m happy. They’re so kind and professional, and I always leave not just with beautiful nails, but also feeling refreshed and cared for.”",
    avatar: "https://i.imgur.com/g7mJPq8.png",
  },
  {
    name: "Emily Carter",
    feedback:
      "“This salon is absolutely beautiful and always spotless. There are so many gorgeous colors to choose from that it’s almost impossible to decide, but the staff are so patient and helpful. They really take their time to make sure everything is done perfectly, and the end result always exceeds my expectations. Definitely my favorite spot in town for a bit of self-care.”",
    avatar: "https://i.imgur.com/VxekuRS.png",
  },
  {
    name: "Sophia Bennett",
    feedback:
      "“I booked a last-minute manicure here, and I’m so glad I did. The whole process felt effortless and relaxing, and the finish on my nails is absolutely flawless. What really impressed me is how long it’s lasted compared to other places I’ve tried — I didn’t have to worry about chips or fading. I’ll definitely be coming back again and again.”",
    avatar: "https://i.imgur.com/0JaNnhK.png",
  },
  {
    name: "Olivia Green",
    feedback:
      "“I had both a manicure and pedicure here, and each time was such a wonderful experience. The staff are so friendly and attentive, and the salon itself is incredibly clean and inviting. The results are amazing — my nails look gorgeous and my feet feel so soft. I always look forward to my next visit because I know I’ll leave feeling pampered.”",
    avatar: "https://i.imgur.com/aCEUi1W.png",
  },
  {
    name: "Amelia Hughes",
    feedback:
      "“I walked in without an appointment and was pleasantly surprised to be seen right away. The whole atmosphere was warm and welcoming, and the team made me feel completely comfortable. The gel nails I had done are honestly the best I’ve ever had — shiny, strong, and beautifully done. It’s rare to find a place that combines such great service with such skill. Highly recommend!”",
    avatar: "https://i.imgur.com/F7M14q2.png",
  },
  {
    name: "Grace Mitchell",
    feedback:
      "“This is such a lovely clean salon with an incredibly relaxing vibe. The attention to detail was fantastic, and my acrylic nails turned out beautifully. The pedicure chairs are so comfortable that I nearly fell asleep! It’s more than just a nail appointment here — it feels like a little escape where I can recharge and leave looking and feeling better than ever.”",
    avatar: "https://i.imgur.com/KxhUFKM.jpg",
  },
  {
    name: "Hannah Ward",
    feedback:
      "“I brought my sister here as a treat, and we both loved every moment of it. From the warm welcome to the attentive care throughout, the team made us feel special. We chatted, laughed, and left with nails that looked absolutely amazing. It was such a lovely experience to share, and now we’ve both decided this will be our regular spot for pampering.”",
    avatar: "https://i.imgur.com/kI3rsKc.jpg",
  },
]


export const MENU_HEADER = [
  { name: "Home", navigationKey: "home" },
  { name: "About Us", navigationKey: "about-us" },
  { name: "Services", navigationKey: "services" },
  // { name: "Booking", navigationKey: NAIL_SHOP_INFO.bookingUrl },
  // { name: "Contacts", navigationKey: "contactsRef" },
  { name: "Contact", navigationKey: "contact-us" },
  { name: "Policy", navigationKey: "policy" },
];
